import React from 'react';
import IconWrapper from '../../../IconWrapper';
const CustomerServiceIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { d: "M8.268 9.333H2.667V2.667h10.666v6.666h-2.666v1.885l-2.4-1.885Zm4.399 2h.666a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2H2.667a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h4.909l5.09 4v-4ZM11 4.98H5v2h6v-2Z" })));
export default CustomerServiceIconSmall;
//# sourceMappingURL=CustomerServiceIconSmall.js.map